<template>
  <div>
    <x-table
      listApi="biz.warehouse.goods.zsm.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无追溯码信息"
      :fieldList="fieldList"
      :defaultParams="defaultParams"
      :actionWidth="100"
    >
      <template slot="row-info" slot-scope="scope">
        <div>
          <span>
            {{ scope.row.zsmCode }}
          </span>
        </div>
        <div style="color: #919191; font-size: 14px">
          <span> 入库时间: </span>
          <span style="color: #333333">
            {{
              new Date(scope.row.inboundTime).format("YYYY-MM-dd hh:mm:ss") ||
              ""
            }}
          </span>
        </div>
        <div v-if="scope.row.validDate" style="color: #919191; font-size: 14px">
          <span> 生产批次: </span>
          <span style="color: #333333">
            {{ scope.row.batchCode }}
          </span>
        </div>
        <div v-if="scope.row.packDate" style="color: #919191; font-size: 14px">
          <span> 生产日期: </span>
          <span style="color: #333333">
            {{ scope.row.packDate }}
          </span>
        </div>
        <div v-if="scope.row.validDate" style="color: #919191; font-size: 14px">
          <span> 有效日期: </span>
          <span style="color: #333333">
            {{ scope.row.validDate }}
          </span>
        </div>
        <div
          v-if="scope.row.inboundHandleBy"
          style="color: #919191; font-size: 14px"
        >
          <span> 经手人员: </span>
          <span style="color: #333333">
            {{ scope.row.inboundHandleBy }}
          </span>
        </div>
      </template>
    </x-table>
  </div>
</template>

<style lang="less" scoped>
.stock-title {
  font-size: 16px;
  font-weight: bolder;
  line-height: 35px;
}
</style>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        storeGuid: this.pageParams.storeGuid,
        goodsGuid: this.pageQuery.guid,
      };
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "追溯码信息",
          minWidth: '220',
          slot: "info",
        },
      ],
    };
  },
};
</script>
